import React, { FunctionComponent } from "react";
import Anchor from "components/Anchor/Anchor";
import styles from "./Employee.module.scss";
import EmployeeContent from "./EmployeeContent.model";
import getImageCrop from "app/media/helpers/getImageCrop";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import IconViewer from "components/IconViewer/IconViewer";
import getProcessedRichtext from "blocks/helpers/getProcessedRichtext";
import formatDynamicTextBreak from "blocks/helpers/formatDynamicTextBreak";

const Employee: FunctionComponent<EmployeeContent> = (props) => {
    const media = props?.media;
    const imageCrop = getImageCrop(media?.crops, undefined, "Square (1:1)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, media?.width, media?.height);
    const colorValue = props?.backgroundColor?.color;
    const bgColor = colorValue ? (colorValue.startsWith("#") ? colorValue : `#${colorValue}`) : undefined;
    const processedHeadline = getProcessedRichtext(formatDynamicTextBreak(props?.headline));

    return (
        <div
            className={styles.wrapper}
            style={{ "--background-color": bgColor } as React.CSSProperties}
        >
            {/* Media*/}
            {media !== null ? (
                <ImageViewer
                    className={styles.image}
                    src={media?.url || media}
                    type="containX"
                    crop={imageCrop}
                    focalPoint={media?.focalPoint}
                    {...imageAspectRatio}
                    alt={""}
                />
            ) : null}

            {/* Clip Path Definition for Firefox - Shape() not supported https://caniuse.com/?search=shape*/}
            <svg
                width="0"
                height="0"
                style={{ position: "absolute" }}
            >
                <defs>
                    <clipPath
                        id="clip-employees-shape"
                        clipPathUnits="objectBoundingBox"
                    >
                        <path
                            d="
                    M 0.96 0
                    C 0.9706 0.0005 0.9982 0.0006 1 0.0007
                    L 1 1
                    L 0 1
                    L 0 0.6046
                    C 0 0.6046 0.0308 0.5875 0.039 0.5829
                    C 0.045 0.5797 0.06 0.5701 0.0724 0.5615
                    C 0.0757 0.5593 0.0827 0.5542 0.0882 0.5502
                    C 0.10 0.5414 0.1282 0.5188 0.1513 0.4997
                    C 0.166 0.4874 0.1993 0.4582 0.2256 0.4345
                    C 0.2426 0.419 0.2799 0.3863 0.3088 0.3615
                    C 0.3277 0.3453 0.3679 0.3133 0.3987 0.29
                    C 0.4191 0.2745 0.4609 0.2427 0.4922 0.2191
                    C 0.535 0.1846 0.6181 0.1287 0.6778 0.0942
                    C 0.6979 0.0814 0.7366 0.0616 0.7643 0.05
                    C 0.7735 0.0456 0.7915 0.0383 0.8046 0.0337
                    C 0.8133 0.0301 0.8303 0.0244 0.8424 0.021
                    C 0.8506 0.0181 0.8662 0.014 0.8772 0.0117
                    C 0.8847 0.0093 0.8988 0.0065 0.9088 0.0054
                    C 0.9155 0.0039 0.9279 0.0021 0.9364 0.0015
                    C 0.9424 0.0012 0.9529 0.0005 0.96 0
                    Z"
                        />
                    </clipPath>
                </defs>
            </svg>

            {/* Content */}
            <div className={styles.content}>
                <div className={styles.text_content}>
                    {props?.headline ? (
                        <div
                            className={styles.headline}
                            dangerouslySetInnerHTML={processedHeadline}
                        ></div>
                    ) : null}

                    {props?.tagline ? <div className={styles.tagline}>{props?.tagline}</div> : null}
                    <div className={styles.links}>
                        {props?.phoneNumber ? (
                            <a
                                className={styles.link}
                                href={`tel:${props?.phoneNumber}`}
                            >
                                <span className={styles.link_label}>{props?.phoneNumber}</span>
                                <IconViewer
                                    className={styles.link_icon}
                                    name="phone"
                                />
                            </a>
                        ) : null}

                        {props?.email ? (
                            <a
                                className={styles.link}
                                href={`mailto:${props?.email}`}
                            >
                                <span className={styles.link_label}>{props?.email}</span>
                                <IconViewer
                                    className={styles.link_icon}
                                    name="mail"
                                />
                            </a>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Employee;
